<template>
  <div id="chart">
    <VueApexCharts type="donut" ref="chart" width="100%" :options="chartOptions" :series="series"></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "ApexGradientDonutChart",
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      require: true,
    },
    label: {
      type: Array,
      require: true,
    },
    width: {
      type: Number,
      require: false,
      default: 380,
    },
    dark: {
      type: Boolean,
      require: false,
      default: false,
    },
    header: {
      type: String,
      require: true,
    },
  },

  data: () => ({
    timer: null,

    shadeTo: "light",
    mode: "light",

    series: [],
    chartOptions: {
      stroke: {
        show: true,
        curve: "smooth",
        lineCap: "butt",
        colors: undefined,
        width: 2,
        dashArray: 0,
      },

      states: {
        hover: {
          filter: {
            type: "none",
          },
        },
      },
      chart: {
        width: 320,
        type: "donut",
        background: "transparent",
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return Math.round(val) + "%";
        },
      },

      fill: {
        type: "gradient",
      },
      legend: {
        position: "bottom",
        formatter: function(val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex] + " kW";
        },
      },
      title: {
        text: "Poměr výkonů jednotlivých elektráren",
      },
      theme: {
        palette: "palette8",
        monochrome: {
          enabled: true,
          color: "#F9C80E",
          shadeTo: "light",
          shadeIntensity: 0.25,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            /*             chart: {
              width: 200,
            }, */
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  }),
  created() {},
  mounted() {
    this.updateChart();
    this.setTheme();
  },
  methods: {
    updateChart() {
      this.series = [];

      for (let index = 0; index < this.data.length; index++) {
        if (this.data[index] < 0) {
          this.data = 0;
        }
      }

      this.series = this.data;

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          labels: this.label,
        },
      };

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          chart: {
            width: this.width,
            type: "donut",
            background: "#00000000",
          },
        },
      };

      this.$refs.chart.refresh();
    },
    setTheme() {
      if (this.dark === true) {
        this.shadeTo = "dark";
        this.mode = "dark";
        this.updateTheme();
      } else {
        this.shadeTo = "light";
        this.mode = "light";
        this.updateTheme();
      }
    },
    updateTheme() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
            palette: "palette8",
            monochrome: {
              enabled: true,
              color: "#F9C80E",
              shadeTo: this.shadeTo,
              shadeIntensity: 0.25,
            },
          },
        },
      };

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          chart: {
            width: this.width,
            type: "donut",
            background: "#00000000",
          },
        },
      };
    },
  },
  watch: {
    data: function() {
      this.updateChart();
    },
    label: function() {
      this.updateChart();
    },
    width: function() {
      this.updateChart();
    },
    dark: function() {
      this.setTheme();
    },
    header: function() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          title: {
            text: this.$i18n.t("powerplant.donut"),
          },
        },
      };
    },
  },
};
</script>

<style scoped>
/* svg.apexcharts-svg {
  background: transparent !important;
} */

/* .apexcharts-canvas {
  background: transparent !important;
} */
</style>
